import { render } from "./InfoCart.vue?vue&type=template&id=628996e9&scoped=true"
import script from "./InfoCart.vue?vue&type=script&lang=js"
export * from "./InfoCart.vue?vue&type=script&lang=js"

import "./InfoCart.vue?vue&type=style&index=0&id=628996e9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628996e9"]])

export default __exports__